import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Box,
  Card,
  CardContent,
  Grid,
} from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useAuth } from '../contexts/AuthContext';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Welcome, {user?.fullName}!
      </Typography>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Submit New Report
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Create a new time report for your work
              </Typography>
              <Button
                variant="contained"
                startIcon={<AssignmentIcon />}
                onClick={() => navigate('/report/new')}
                fullWidth
              >
                Submit Report
              </Button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                View Reports
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                View and manage your submitted reports
              </Typography>
              <Button
                variant="outlined"
                onClick={() => navigate('/reports')}
                fullWidth
              >
                View Reports
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Dashboard;




